// Xartis logomark — a "charted route": a path from a start point to a destination ring.
// Nods to the Greek χάρτης (map/chart) and to planning in phases. Inherits currentColor
// so it adapts to light/dark headers. Not an "X".
export default function Logomark({ size = 26, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      role="img"
      aria-label="Xartis"
    >
      <path
        d="M6 25 L13 14 L20 18 L26 8"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="6" cy="25" r="2.8" fill="currentColor" />
      <circle cx="26" cy="8" r="3.4" stroke="currentColor" strokeWidth="2.4" />
    </svg>
  );
}
